import { makeStyles, createStyles } from '@material-ui/core'
import {GREY_INFO_COLOR} from "../../../../../../../../../../themes/themeConfigurator";

export const styles = theme => createStyles({
  container: {
    backgroundColor: 'white',
    borderRadius: '0px 0px 4px 4px',
  },

  titleSection: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 0,
    borderBottom: '1px solid #EAEDF3',
  },
  titleHintSection: {
    marginTop: -10
  },

  title: {
    fontFamily: 'Roboto-Bold',
    color: '#202A38',
    fontSize: 18
  },

  bankName: {
    fontFamily: 'Roboto-Medium',
    color: '#202A38',
    marginBottom: 15,
    marginTop: 15
  },

  documentsSection: {
    marginTop: 0,
  },

  formControlLabelDisabled: {
    color: '#202A38 !important',
    fontFamily: 'Roboto-Regular',
    fontSize: 16
  },
  formControlLabelRoot: {
    marginRight: '0 !important',
    marginBottom: '0 !important',
    marginLeft: 0,
  },

  selectAllCheckboxSection: {
  },

  documentItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 6,
    position: 'relative',
    borderBottom: '1px solid #EAEDF3',
    '&.headline': {
      background: '#F9F9F9',
      color: GREY_INFO_COLOR
    },
    '& > *': {
      flex: '0 0 auto',
    },
    '& > div:first-child': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: 'calc(100% - 240px)',
      height: 45,
      padding: '0 5px',
      paddingRight: theme.spacing(2),
      overflowX: 'hidden',
      fontFamily: 'Roboto-Regular',

      '& > span:first-child': {
        whiteSpace: 'nowrap',
        display: 'inline-block',
        width: 'calc(100% - 90px)',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    }
  },

  checkboxes: {
    display: 'flex',
    width: 240,
    flexWrap: 'wrap',
    '& > div': {
      width: 75,
      flexBasis: '50%',
      display: 'flex',
      alignItems: 'center',

      '& > span': {
        fontFamily: 'Roboto-Bold',
        fontSize: 14
      }
    }
  },

  previewButton: {
    color: theme.palette.primary.main,
    fontFamily: 'Roboto-Bold',
    fontHeight: 14,
    whiteSpace: 'nowrap',
    '&:hover': {
      cursor: 'pointer'
    }
  },

  infoIcon: {
    '& > svg > path': {
      fill: theme.palette.primary.main
    },
    marginRight: 10
  },

  errorMessage: {
    fontFamily: 'Roboto-Regular !important',
    fontSize: '12px !important',
    color: 'red',
    fontWeight: 'normal',
    whiteSpace: 'nowrap',
    display: 'inline-block',
    marginTop: 10,
    position: 'relative',
  },

  documentsManagementButton: {
    margin: '15px 0px 13px'
  },
  tooltip: {
    fontSize: 12,
  },
  tooltipPopper: {
    top: '12px !important'
  },
  onlineChip: {
    color: GREY_INFO_COLOR,
    background: 'rgba(131, 138, 147, 0.12)',
    height: 25,
    fontFamily: 'Roboto-Regular',
  }
});

export default makeStyles(styles)